
import { butter } from "../../plugins/buttercms";
import { getMetaTags } from "../../utils/metaTagsHelper";
import schemaArticle from '~/utils/articleSchema.js'

export default {
  name: "about-callia",
  data() {
    return {
      pageData: {},
      metaTags: null,
      articleSchemaStructure:schemaArticle,
      vFeatureSchema:[],
      quoteBlockSchema:{},
      vFeature2Schema:[],
      hContentSchema:[],
    };
  },
  head() {
    return getMetaTags(this.metaTags);
  },
  async fetch() {
    try {
      const page = await butter(this.$config).page.retrieve(
        "about_us_page",
        "about-us",
        {
          locale: this.$i18n.locale,
          timeout: 10000
        }
      );
      this.pageData = page?.data.data.fields;
      this.metaTags = this.pageData.seo;
      this.setupVFeatureSchema(page);
      this.setupQuoteBlockSchema(page);
      this.setupVFeature2Schema(page);
      this.setupHContentSchema(page);
    } catch (error) {
      console.error(error);
    }
  },
  methods:{
    setupVFeatureSchema(page){
      this.pageData['cal-v-feature-blocks']['cal-v-feature-block'].forEach(slide =>{
        let articleSchema = { ...this.articleSchemaStructure }
        articleSchema.image = [...(this.articleSchemaStructure.image || [])];
        articleSchema.headline=slide.heading
        articleSchema.description=slide.content
        articleSchema.image.push(slide.image)
        articleSchema.mainEntityOfPage['@id']='https://callia.com/en-ca/about-callia'
        articleSchema.datePublished=page?.data.data.published
        articleSchema.dateModified=page?.data.data.updated
        this.vFeatureSchema.push(articleSchema)
      })
    },
    setupQuoteBlockSchema(page){
      let articleSchema = { ...this.articleSchemaStructure }
      articleSchema.image = [...(this.articleSchemaStructure.image || [])];
      articleSchema.headline=this.pageData["cal-quote-block"].name +this.pageData["cal-quote-block"].designation 
      articleSchema.description=this.pageData['cal-quote-block'].quote
      articleSchema.image.push(this.pageData['cal-quote-block'].image);
      articleSchema.mainEntityOfPage['@id']='https://callia.com/en-ca/about-callia'
      articleSchema.datePublished=page?.data.data.published
      articleSchema.dateModified=page?.data.data.updated
      this.quoteBlockSchema=articleSchema;
    },
    setupVFeature2Schema(page){
      this.pageData['cal-v-feature-blocks2']['cal-h-feature-block'].forEach(slide =>{
        let articleSchema = { ...this.articleSchemaStructure }
        articleSchema.image = [...(this.articleSchemaStructure.image || [])];
        articleSchema.headline=slide.heading
        articleSchema.description=slide.content
        articleSchema.image.push(slide.image)
        articleSchema.mainEntityOfPage['@id']='https://callia.com/en-ca/about-callia'
        articleSchema.datePublished=page?.data.data.published
        articleSchema.dateModified=page?.data.data.updated
        this.vFeature2Schema.push(articleSchema)
      })
    },
    setupHContentSchema(page){
      this.pageData['cal-h-content-blocks']['h-content-block'].forEach(slide =>{
        let articleSchema = { ...this.articleSchemaStructure }
        articleSchema.image = [...(this.articleSchemaStructure.image || [])];
        articleSchema.headline=slide.heading
        articleSchema.description=slide.content
        articleSchema.image.push(slide.image)
        articleSchema.mainEntityOfPage['@id']='https://callia.com/en-ca/about-callia'
        articleSchema.datePublished=page?.data.data.published
        articleSchema.dateModified=page?.data.data.updated
        this.hContentSchema.push(articleSchema)
      })
    }
  }
};
